import { apiClient } from '../../app/api';

export interface BrandProductCountRow {
  brandId: number | null;
  brandName: string;
  productCount: number;
}

export interface CategoryProductCountRow {
  categoryId: number | null;
  categoryName: string;
  productCount: number;
}

export interface OrderLineStatsByBrandRow {
  brandId: number | null;
  brandName: string;
  orderCount: number;
  lineTotalCents: number;
  completedLineTotalCents: number;
}

export interface OrderLineStatsByCategoryRow {
  categoryId: number | null;
  categoryName: string;
  orderCount: number;
  lineTotalCents: number;
  completedLineTotalCents: number;
}

export interface DashboardSummary {
  productCount: number;
  orderCount: number;
  pendingOrders: number;
  completedOrders: number;
  cancelledOrders: number;
  totalRevenueCents: number;
  productsByBrand: BrandProductCountRow[];
  productsByCategory: CategoryProductCountRow[];
  ordersByBrand: OrderLineStatsByBrandRow[];
  ordersByCategory: OrderLineStatsByCategoryRow[];
}

export async function fetchDashboardSummary(): Promise<DashboardSummary> {
  return apiClient.get<DashboardSummary>('/admin/dashboard/summary');
}
